// La ruta del modo Diseño de indumentaria — ADR-2026-09-17-un-diseno-es-un-chat.
// Sin `:disenoId` es la portada; con él, el lienzo del diseño. Gate por rubro adentro del
// componente, como Belleza: la card no se muestra fuera de Moda pero la URL existe. Y
// piso de plan Pro/Ultra, el mismo que ponen las listas con `getModePlanLock`, vuelto a
// mirar acá porque la URL se puede escribir a mano
// (ADR-2026-09-18-el-modo-diseno-se-abre-a-moda-desde-pro; los dev testers pasan, como
// en todos los candados). Sólo escritorio (el lienzo lo es): en mobile la card se ve y
// acá se avisa que se usa desde la computadora.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Monitor } from 'lucide-react';
import { useEsEscritorio } from '../../../../chat-atlas/ui/useEsEscritorio';
import { PantallaDePisoDePlan, usePisoDePlan } from '../../../../components/PisoDePlan';
import { useRubroMarcaActiva } from '../../../../hooks/useRubroMarca';
import { esRubroModa } from '../../../../lib/rubro';
import { LienzoDeDiseno } from './LienzoDeDiseno';
import { PortadaDeDiseno } from './PortadaDeDiseno';

const DisenoIndumentariaMode: React.FC = () => {
  const { disenoId } = useParams<{ disenoId?: string }>();
  const navigate = useNavigate();
  const esEscritorio = useEsEscritorio();
  const { rubro, loaded } = useRubroMarcaActiva();
  // El piso de plan (Pro o Ultra), vuelto a mirar acá: un dev tester pasa.
  const lock = usePisoDePlan('diseno-indumentaria');

  // Con el rubro resuelto y sin ser Moda, a la home; sin resolver no se rebota (echar a
  // quien califica es peor que un instante en blanco).
  useEffect(() => {
    if (loaded && !esRubroModa(rubro)) navigate('/interfaz-v2', { replace: true });
  }, [loaded, rubro, navigate]);

  if (!esEscritorio) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
        <Monitor className="h-8 w-8 text-[rgb(var(--brand-black-rgb)_/_0.4)]" aria-hidden="true" />
        <p className="text-[16px] font-semibold text-brand-black">Disponible en computadora</p>
        <p className="text-[14px] text-[#3C3C43]/60">Diseño de indumentaria se usa desde una computadora: el lienzo necesita pantalla.</p>
      </div>
    );
  }
  if (lock) return <PantallaDePisoDePlan lock={lock} />;
  return disenoId ? <LienzoDeDiseno disenoId={disenoId} /> : <PortadaDeDiseno />;
};

export default DisenoIndumentariaMode;
